import { c as _c } from "react/compiler-runtime";
import { Dropdown, DropdownItem, Search } from 'platform/components';
import { Show } from 'platform/foundation';
import { startTransition, useState } from 'react';
import { TestIdProps, suffixTestId } from 'shared/web';
import { SMART_SEARCH_KEY } from '../../../../constants/smartSearchKey';
import { useSmartSearchFilter } from '../../../../store/selectors/useSmartSearchFilter';
import { useEagGridStore } from '../../../../store/useEagGridStore';
import { useSmartSearchHistory } from './hooks/useSmartSearchHistory';
const ENTER_KEY = 'Enter';
const ESCAPE_KEY = 'Escape';
export type QuickFilterInputProps = {
  initialValue?: string;
  onSubmit?: () => void;
  onEscape?: () => void;
  className?: string;
} & TestIdProps;
export function QuickFilterInput(props) {
  const $ = _c(44);
  const smartSearchValue = useSmartSearchFilter();
  const store = useEagGridStore();
  const history = useSmartSearchHistory();
  const [localValue, setLocalValue] = useState(props.initialValue ?? smartSearchValue);
  const [prevSmartSearch, setPrevSmartSearch] = useState(smartSearchValue);
  if (prevSmartSearch !== smartSearchValue) {
    setPrevSmartSearch(smartSearchValue);
    setLocalValue(smartSearchValue);
  }
  let t0;
  if ($[0] !== history || $[1] !== store) {
    t0 = value => {
      const currentFilters = store.getState().filterValues;
      const nextFilters = {
        ...currentFilters
      };
      if (value) {
        nextFilters[SMART_SEARCH_KEY] = {
          [SMART_SEARCH_KEY]: value
        };
      } else {
        delete nextFilters[SMART_SEARCH_KEY];
      }
      startTransition(() => {
        store.setFilterValues(nextFilters);
      });
      history.refetch();
    };
    $[0] = history;
    $[1] = store;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const submitSearch = t0;
  let t1;
  if ($[3] !== history || $[4] !== localValue || $[5] !== props || $[6] !== submitSearch) {
    t1 = event => {
      if (event.key === ENTER_KEY) {
        event.preventDefault();
        history.closeMenu();
        submitSearch(localValue);
        props.onSubmit?.();
      } else {
        if (event.key === ESCAPE_KEY) {
          history.closeMenu();
          props.onEscape?.();
        }
      }
    };
    $[3] = history;
    $[4] = localValue;
    $[5] = props;
    $[6] = submitSearch;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const handleKeyDown = t1;
  let t2;
  if ($[8] !== history) {
    t2 = value_0 => {
      setLocalValue(value_0 ?? "");
      if (!history.menuOpen) {
        history.openMenu();
      }
    };
    $[8] = history;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const handleChange = t2;
  let t3;
  if ($[10] !== submitSearch) {
    t3 = () => {
      setLocalValue("");
      submitSearch("");
    };
    $[10] = submitSearch;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const handleClear = t3;
  let t4;
  if ($[12] !== history) {
    t4 = () => {
      history.openMenu();
    };
    $[12] = history;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const handleFocus = t4;
  let t5;
  if ($[14] !== history || $[15] !== submitSearch) {
    t5 = value_1 => {
      setLocalValue(value_1);
      history.closeMenu();
      submitSearch(value_1);
    };
    $[14] = history;
    $[15] = submitSearch;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  const handleOptionClick = t5;
  const t6 = props.className ?? "w-full min-w-0";
  let t7;
  if ($[17] !== props) {
    t7 = suffixTestId("quickFilter", props);
    $[17] = props;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== handleChange || $[20] !== handleClear || $[21] !== handleFocus || $[22] !== localValue || $[23] !== t7) {
    t8 = <Search value={localValue} onChange={handleChange} onClear={handleClear} onFocus={handleFocus} data-testid={t7} />;
    $[19] = handleChange;
    $[20] = handleClear;
    $[21] = handleFocus;
    $[22] = localValue;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  const t9 = history.searchOptions?.length;
  let t10;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div />;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  const t11 = history.menuOpen;
  const t12 = history.closeMenu;
  let t13;
  if ($[26] !== props) {
    t13 = suffixTestId("quickFilterDropdown", props);
    $[26] = props;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== handleOptionClick || $[29] !== history.searchOptions) {
    t14 = history.searchOptions?.map(option => <DropdownItem key={option.value} label={option.label} onClick={() => handleOptionClick(option.value)} />);
    $[28] = handleOptionClick;
    $[29] = history.searchOptions;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== history.closeMenu || $[32] !== history.menuOpen || $[33] !== t13 || $[34] !== t14) {
    t15 = <Dropdown dropdownControl={t10} isOpen={t11} onClose={t12} strategy="fixed" isFocusManagementDisabled={true} data-testid={t13}>{t14}</Dropdown>;
    $[31] = history.closeMenu;
    $[32] = history.menuOpen;
    $[33] = t13;
    $[34] = t14;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t15 || $[37] !== t9) {
    t16 = <Show when={t9}>{t15}</Show>;
    $[36] = t15;
    $[37] = t9;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== handleKeyDown || $[40] !== t16 || $[41] !== t6 || $[42] !== t8) {
    t17 = <div onKeyDown={handleKeyDown} className={t6}>{t8}{t16}</div>;
    $[39] = handleKeyDown;
    $[40] = t16;
    $[41] = t6;
    $[42] = t8;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  return t17;
}